import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../../../../services/AxiosInstance";
import CustomSelect from "../../../Forms/Element/CustomSelect";

/**
 * Exibe um select único de categorias do produto.
 */
const CategorySelect = (props) => {
   
    const { t } = useTranslation();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        axiosInstance.get("/main/categories", null).then((response) => {
            let options = [];

            for (var i = 0; i < response.data.length; i++) {
                options.push(
                    {
                        value: response.data[i].id,
                        label: response.data[i].name
                    }
                );

                setOptions(options);
            }
        });
    }, []);

    return (
        <CustomSelect
            options={options}
            placeholder={t("select")}
            {...props} />
    )
}

export default CategorySelect;
